export default "__VITE_ASSET__CfAzRuYb__"